import type { User } from "@/types";
import { UserRole } from "@/types";

/** True iff the user holds the SUPER_ADMIN role (primary, legacy, or any assignment) —
 *  the single check for "can open the season-transition page" (Paramètres Système). */
export function isSuperAdmin(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role === UserRole.SUPER_ADMIN || user.primaryRole === UserRole.SUPER_ADMIN) return true;
  return (user.roles ?? []).some((a) => a.role === UserRole.SUPER_ADMIN);
}

/** True iff the user holds ADMIN or SUPER_ADMIN: the roles is_admin() lets read the audit
 *  journal (get_audit_logs) and edit any league's PV (can_edit_league_pv). */
export function isAdminOrSuperAdmin(user: User | null | undefined): boolean {
  if (!user) return false;
  const admin = (r: unknown) => r === UserRole.SUPER_ADMIN || r === UserRole.ADMIN;
  if (admin(user.role) || admin(user.primaryRole)) return true;
  return (user.roles ?? []).some((a) => admin(a.role));
}
